<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section class="p-relative">
    <h3 class="mb-2 text-center">Approve Purple Phone Contact?</h3>

    <p class="mb-1">
      If approved <b>{{contact.user.firstname }} {{ contact.user.lastname }}</b> will be able to make calls to prisoner <b>{{contact.prisoner_number}}</b> via purple phone. Are you sure?
    </p>

    <section class="d-inline-flex full-width mt-2" :class="{'disabled': loading}">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="close()">Close</b-button>
      <b-button variant="success" @click="approve()">Approve</b-button>
    </section>
  </section>
</template>
<!--eslint-enable-->

<script>
import ContactService from '@/services/ContactService';

export default {
  components: {},
  props: {
    contact: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async approve() {
      this.loading = true;
      try {
        const { data } = await ContactService.purplePhoneApprove(this.contact._id);
        this.$toast.success('The contact has been approved for purple phone calls', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.$emit('approved', data)
        this.close();
      } catch(err) {
        console.error('Error approving the contact: ', err);
        this.$toast.error('Something went wrong approving the contact, please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit('close', true); // emit a close
    }
  },
};
</script>
